export default "__VITE_ASSET__effaaa35__"